import React, { useEffect, useState } from "react";
import { Drawer, Input } from "@stonelog/stonelog-design-system";
import { GingaIcon } from "@stonelog/stonelog-ginga-icons";
import { useSelector } from "react-redux";
import { pinsSelector, setBouncePin, setCenter, setZoom } from "../../../../../../../features/senninha/pinsSlice";
import { useDispatch } from "react-redux";

import * as S from "./styles";


const SearchDrawer = () => {

    const [foundSearchResult, setFoundSearchResult] = useState(null)
    const [searchValue, setSearchValue] = useState(null)
    const [typedValue, setTypedValue] = useState(null)

    const dispatch = useDispatch();

    const {
        pins,
        filteredPins
    } = useSelector(pinsSelector);

    const handlePressEnter = (e) => {
        const value = e.target.value.trim();

        const foundPin = pins.find(pin => {
            return pin.id_atendimento === value ||
                pin.oss.some(os => os.id_os?.toString() === value) || pin.contato === value;
        });

        setFoundSearchResult(foundPin);
        setTypedValue(value);
    }

    useEffect(() => {
        if (foundSearchResult !== undefined && foundSearchResult !== null) {
            dispatch(setCenter({
                center: {
                    lat: parseFloat(foundSearchResult.lat),
                    lng: parseFloat(foundSearchResult.lng)
                }
            }))
            dispatch(setBouncePin(foundSearchResult.id))
            dispatch(setZoom(30))
            setFoundSearchResult(null)
        }
    }, [typedValue, foundSearchResult]);

    useEffect(() => {
        if (!searchValue) {
            setTypedValue('')
            setFoundSearchResult(null)
        }
    }, [searchValue])

    const atendimentoMatches = (idAtendimento, search) => {
        if (!idAtendimento) return false;

        if (Array.isArray(idAtendimento)) {
            return idAtendimento.some((id) => id.toLowerCase().includes(search.toLowerCase()));
        }

        return idAtendimento.toLowerCase().includes(search.toLowerCase());
    };

    return (
        <Drawer.Body>
            <S.AllSearchDrawerContent>
                <Input
                    label="Pesquisar"
                    placeholder="Stonecode, cliente ou cód. rastreio"
                    size="small"
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    suffixIcon={<GingaIcon name='search' color='#767F8D' size='18px' />}
                    onPressEnter={(e) => handlePressEnter(e)}
                    allowClear
                />
                {
                    foundSearchResult === undefined && (
                        <Drawer.EmptySearch message={`Nenhum resultado para “${typedValue}”.`} style={{ height: '90%' }} />
                    )
                }
                {(searchValue?.length > 0 && foundSearchResult !== undefined) && (
                    <S.DropDown>
                        {[...new Map(
                            filteredPins
                                .filter(
                                    (pin) =>
                                        atendimentoMatches(pin.id_atendimento, searchValue) ||
                                        pin.oss?.some((os) => os.id_os?.toString().includes(searchValue)) ||
                                        pin.contato?.toLowerCase().includes(searchValue.toLowerCase()) ||
                                        pin.cliente?.toLowerCase().includes(searchValue.toLowerCase())
                                )
                                .map((pin) => {
                                    const matchesAtendimento = atendimentoMatches(pin.id_atendimento, searchValue);

                                    const value = matchesAtendimento
                                        ? Array.isArray(pin.id_atendimento)
                                            ? pin.id_atendimento.find((id) =>
                                                id.toLowerCase().includes(searchValue.toLowerCase())
                                            )
                                            : pin.id_atendimento
                                        : pin.oss?.find((os) => os.id_os?.toString().includes(searchValue))?.id_os ?? (
                                            pin.contato?.toLowerCase().includes(searchValue.toLowerCase()) ? pin.contato :
                                            (pin.cliente?.toLowerCase().includes(searchValue.toLowerCase()) ? pin.cliente : null)
                                        );

                                    return value ? [value, pin] : null;
                                })
                                .filter(Boolean)
                        ).values()].map((pin, idx) => {
                            const matchesAtendimento = atendimentoMatches(pin.id_atendimento, searchValue);

                            const matchingOs = pin.oss?.find((os) =>
                                os.id_os?.toString().includes(searchValue)
                            );

                            const matchingContact = pin.contato?.toLowerCase().includes(searchValue.toLowerCase()) ? pin.contato : null;
                            const matchingClient = pin.cliente?.toLowerCase().includes(searchValue.toLowerCase()) ? pin.cliente : null;

                            const displayValue = matchesAtendimento
                                ? (Array.isArray(pin.id_atendimento) ? pin.id_atendimento.find((id) => id.toLowerCase().includes(searchValue.toLowerCase())) : pin.id_atendimento)
                                : matchingOs?.id_os ?? matchingContact ?? matchingClient;

                            return (
                                <S.DropDownItems
                                    key={idx}
                                    onClick={() => {
                                        setFoundSearchResult(pin);
                                        setTypedValue(displayValue);
                                    }}
                                >
                                    {displayValue}
                                </S.DropDownItems>
                            );
                        })}
                    </S.DropDown>
                )}


            </S.AllSearchDrawerContent>
        </Drawer.Body>
    )
}

export default SearchDrawer;
